import { Styles } from 'react-jss'
import colors from 'lib/colors'

export const sheet = (aboutImg: string): Styles => ({
  title: {
    marginTop: 0,
    fontWeight: 500,
    fontSize: 17,
    color: '#080910',
    '@media (max-width: 768px)': {
      paddingLeft: '1vw'
    }
  },
  text: {},
  hideBlock: {},
  root: {
    display: 'block',
    position: 'relative',
    overflow: 'hidden'
  },
  anchor: {
    scrollMarginTop: 72,
    '@media (max-width: 992px)': {
      scrollMarginTop: 64
    }
  },
  component: {
    display: 'grid',
    padding: '6% 0',
    gridTemplateColumns: '1fr 4fr 20px 4fr 1fr',
    borderBottom: '1px solid #DEDEDE'
  },
  componentDarker: {
    background: colors.neutral300
  },
  leftBlock: {
    gridColumn: '2'
  },
  titleBlock: {
    padding: '20px 40px',
    '& > h3': {
      marginTop: 0,
      marginBottom: 0,
      lineHeight: '1.5em'
    },
    '& > p': {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
      color: colors.text,
      marginBottom: 16
    },
    '& > ul': {
      listStyleType: 'disc',
      paddingLeft: 20,
      margin: '0 0 24px',
      '& > li': {
        marginBottom: 10,
        fontWeight: 400,
        fontSize: 16,
        lineHeight: '24px',
        letterSpacing: '0.01em',
        color: colors.text
      }
    }
  },
  rightBlock: {
    gridColumn: '4'
  },
  featuresBlock: {
    display: 'grid',
    gap: '16px'
  },
  imgAbout: {
    backgroundImage: `url(${aboutImg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    borderRadius: 12,
    minHeight: 360,
    boxShadow: '0 2px 20px rgba(0,0,0,.08)'
  },
  iconBlock: {
    display: 'flex',
    '& > div': {
      position: 'relative',
      padding: '0 1vw 0 6vw',
      flex: 1,
      '& > $text': {
        fontWeight: 400,
        fontSize: 15,
        color: colors.textMuted
      },
      '& > svg': {
        position: 'absolute',
        top: 0,
        left: '10%'
      }
    },
    '& > div:last-child': {
      paddingLeft: '6vw'
    }
  },
  candidates: {
    position: 'relative',
    '& > h3': {
      position: 'absolute',
      top: '5vw',
      left: '17vw',
      margin: 0
    }
  },
  number: {
    fontFamily: 'Roboto Condensed, sans-serif',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '30vw',
    textAlign: 'center',
    letterSpacing: '-0.01em',
    color: colors.textLight,
    opacity: 0.5,
    whiteSpace: 'nowrap'
  },
  '@media (max-width: 768px)': {
    component: {
      gridTemplateColumns: '1fr 5fr 5fr 1fr'
    },
    leftBlock: {
      gridColumn: '2 / 2 span',
      margin: '0 0 9% 0'
    },
    rightBlock: {
      gridColumn: '2 / 2 span'
    },
    iconBlock: {
      '& > div': {
        padding: '0 7vw 7vw',
        '& > svg': {
          left: 0
        }
      }
    },
    hideBlock: {
      display: 'none'
    },
    candidates: {
      position: 'relative',
      padding: '15% 0',
      '& > h3': {
        lineHeight: '56px'
      }
    },
    number: {
      fontSize: 122,
      lineHeight: '152px'
    }
  },
  '@media (max-width: 600px)': {
    iconBlock: {
      flexDirection: 'column'
    }
  }
})
